import React, { useEffect, useState } from 'react';
import { Table, Button, Space, Tag } from 'antd';
import { supabase } from '../../supabaseClient';

const GroupList: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    setLoading(true);
    const { data: groups } = await supabase.from('u_groups').select('*').order('group_id', { ascending: true });
    setData(groups || []);
    setLoading(false);
  };

  const columns = [
    { title: '创建时间', dataIndex: 'created_at', key: 'created_at', width: 60, ellipsis: true, render: (text: string) => text ? new Date(text).toLocaleString('zh-CN', { hour12: false }) : '' },
    { title: '分组ID', dataIndex: 'group_id', key: 'group_id', width: 30, ellipsis: true },
    { title: '分组名称', dataIndex: 'group_name', key: 'group_name', width: 30, ellipsis: true },
    { title: '描述', dataIndex: 'description', key: 'description', width: 30, ellipsis: true },
    {
      title: '策略',
      key: 'policy',
      width: 160,
      render: (_: any, record: any) => {
        const p = record.policy || {};
        // 主策略合并单元格
        if (p.main) {
          return (
            <div>
              <div><b>主</b> 地址：{p.main.address || '-'} &nbsp; 分成：{p.main.percentage != null ? `${(p.main.percentage * 100).toFixed(2)}%` : '-'}</div>
            </div>
          );
        }
        // 普通策略
        return (
          <div>
            <div><b>设备</b> 地址：{p.device?.address || '-'} &nbsp; 分成：{p.device?.percentage != null ? `${(p.device.percentage * 100).toFixed(2)}%` : '-'}</div>
            <div><b>市场</b> 地址：{p.market?.address || '-'} &nbsp; 分成：{p.market?.percentage != null ? `${(p.market.percentage * 100).toFixed(2)}%` : '-'}</div>
            <div><b>社区</b> 地址：{p.community?.address || '-'} &nbsp; 分成：{p.community?.percentage != null ? `${(p.community.percentage * 100).toFixed(2)}%` : '-'}</div>
          </div>
        );
      }
    },
  ];

  return (
    <div style={{ overflowX: 'auto', background: '#fff', padding: 12 }}>
      <Table
        rowKey="uuid"
        columns={columns}
        dataSource={data}
        loading={loading}
        bordered
        pagination={{ pageSize: 15, showSizeChanger: false, showTotal: (total) => `共 ${total} 条数据`, position: ['bottomRight'] }}
        scroll={{ x: 350 }}
        size="small"
        style={{ minWidth: 200 }}
        tableLayout="fixed"
      />
    </div>
  );
};

export default GroupList;
